import Testimonials from "./Testimonial"
export default Testimonials
